/** Whether an async loyalty package upgrade recheck still owns the visible checking modal. */
export default function isLoyaltyUpgradeRecheckModalCurrent(
  modal: App.UiModalState,
  recheckKey: string,
): boolean {
  return modal.open &&
    modal.modalType === 'loyaltyUpgradeRejected' &&
    modal.loyaltyUpgradeRejected?.outcome === 'checking' &&
    modal.loyaltyUpgradeRejected.recheckKey === recheckKey
}
